
import App from './App.vue'
import CategoryPage from './components/CategoryPage/CategoryPage.vue'
import HomePage from './components/HomePage/HomePage.vue'
import PlantPage from './components/PlantPage/PlantPage.vue'
import NotFoundPage from './components/NotFoundPage/NotFoundPage.vue'
import IdentifyPage from './components/IdentifyPage/IdentifyPage.vue'
import ShrubTreePage from './components/ShrubTree/ShrubTreePage.vue'
import SearchPage from './components/SearchPage/SearchPage.vue'

/* add fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'
import { faSearch, faBars, faTimes, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
library.add(faSearch, faBars, faTimes, faChevronRight)

import * as Vue from 'vue' // in Vue 3
import axios from 'axios'
import VueAxios from 'vue-axios'
import { h } from 'vue'
import * as VueRouter from "vue-router";

const routes = [
    {
        path: '/home', component: HomePage, name: 'HomePage', meta: {
            breadCrumb: [
                {
                    text: 'Home'
                }
            ]
        }
    },
    {
        path: '/', component: HomePage, name: 'HomePage', alias: '/home', meta: {
            breadCrumb: [
                {
                    text: 'Home'
                }
            ]
        }
    },
    {
        path: '/plants/:id', component: PlantPage, name: "PlantPage", meta: {
            breadCrumb:
                [
                    {
                        text: 'Home',
                        to: { name: 'HomePage' }
                    },
                    {
                        text: 'PlantName',
                    },
                ]
        }
    },
    {
        path: '/category/:keyCategory', component: CategoryPage, name: "CategoryPage",
        meta: {
            breadCrumb(route) {
                return [
                    {
                        text: 'Home',
                        to: { name: 'HomePage' }
                    },
                    {
                        text: 'New Zealand',
                        to: { path: `/category/all` },
                        tooltip: "All Plants"
                    },
                    {
                        text: route.params.keyCategory,
                    }
                ]
            }
        },
        beforeEnter: (to, from, next) => {
            if (to.params.keyCategory === 'tree' ||
                to.params.keyCategory === 'flower' ||
                to.params.keyCategory === 'all' ||
                to.params.keyCategory === 'fern' ||
                to.params.keyCategory === 'grass' ||
                to.params.keyCategory === 'succulent'
            ) {
                return next()
            } else {
                return next('/:pathMatch(.*)*')
            }
        },
    },
    {
        path: '/identify-leaf', component: IdentifyPage, meta: {
            breadCrumb:
                [
                    {
                        text: 'Home',
                        to: { name: 'HomePage' }
                    },
                    {
                        text: 'Identify leaves',
                    },
                ]
        }
    },
    {
        path: '/shrub-tree', component: ShrubTreePage, meta: {
            breadCrumb:
                [
                    {
                        text: 'Home',
                        to: { name: 'HomePage' }
                    },
                    {
                        text: 'Shrub or Tree',
                    },
                ]
        }
    },
    {
        path: '/search', name: "search", component: SearchPage, meta: {
            breadCrumb() {
                return [
                    {
                        text: 'Home',
                        to: { name: 'HomePage' }
                    },
                    {
                        text: 'New Zealand',
                        to: { path: `/category/all` },
                        tooltip: "All Plants"
                    },
                    {
                        text: 'Search',
                    }
                ]
            }
        },
    },
    { path: '/:pathMatch(.*)*', component: NotFoundPage }

]

export const router = VueRouter.createRouter({
    history: VueRouter.createWebHistory(),
    routes,
})
const app = Vue.createApp({
    render: () => h(App)
});
app.config.globalProperties.colorHexaCategoryList = [
    {
        color: "#1EAE98", key: 'tree'
    },
    {
        color: "#EA047E", key: 'flower'
    },
    {
        color: "#FF8E00", key: 'fern'
    },
    {
        color: "#332FD0", key: 'grass'
    },
    {
        color: "#332FD0", key: 'succulent'
    },
]

app.component("font-awesome-icon", FontAwesomeIcon)/* add font awesome icon component */
app.use(VueAxios, axios)
app.provide('axios', app.config.globalProperties.axios)  // provide 'axios'
app.use(router)
app.mount("#app");